import { Injectable, computed, signal } from '@angular/core';

/**
 * Compte les bottom sheets ouvertes.
 *
 * La nav flottante doit disparaître dès qu'une sheet s'ouvre : elle flotte à
 * 22 px du bas et passerait sinon par-dessus le panneau. Un compteur plutôt
 * qu'un booléen, parce que deux sheets peuvent se recouvrir (une sheet ouvrant
 * une confirmation) et que la fermeture de la première ne doit pas faire
 * réapparaître la nav sous la seconde.
 */
@Injectable({ providedIn: 'root' })
export class SheetService {
  private readonly openCount = signal(0);

  /** `true` tant qu'au moins une sheet est ouverte. */
  readonly anyOpen = computed(() => this.openCount() > 0);

  register(): void {
    this.openCount.update((n) => n + 1);
  }

  unregister(): void {
    this.openCount.update((n) => Math.max(0, n - 1));
  }
}
